import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const normalizeHashUrl = () => {
	const { pathname, search, hash } = window.location;

	if (!pathname || pathname === "/") {
		return;
	}

	if (hash.startsWith("#/")) {
		window.history.replaceState(null, "", `/${hash}`);
		return;
	}

	if (pathname !== "/index.html") {
		window.history.replaceState(null, "", `/#${pathname}${search}`);
	}
};

normalizeHashUrl();

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
